import { objectsRHandler } from '@/utils/objectsRHandler';
import { getApiData, API_TYPES } from '@/utils/modelsApi';
import { ROLES } from '@/constants/roles';

import EventAssociation from '../list/event-association';

const PRIVATE_ROLES = [ROLES.organization, ROLES.admin];
const API_DATA = {
  [API_TYPES.private]: {
    path: 'event-associations',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, EventAssociation),
      };
    },
  },
  [API_TYPES.public]: {
    path: 'public/event-associations',
    get objects() {
      const { path } = this;
      return {
        ...objectsRHandler(path, EventAssociation),
      };
    },
  },
};

export const EventAssociationsManager = {
  get objects() {
    return { ...getApiData(API_DATA, PRIVATE_ROLES).objects };
  },
};
